import { render, staticRenderFns } from "./ItakuApp.vue?vue&type=template&id=23d600d0&"
import script from "./ItakuApp.vue?vue&type=script&lang=ts&"
export * from "./ItakuApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports